var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _line, _path, _rect5, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHdd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50.75,
    y: 18.75,
    width: 2.5,
    height: 2.5,
    fill: "#00C7FD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50.75,
    y: 39.75,
    width: 2.5,
    height: 2.5,
    fill: "#00C7FD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.75,
    y: 39.75,
    width: 2.5,
    height: 2.5,
    fill: "#00C7FD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.75,
    y: 18.75,
    width: 3.5,
    height: 3.5,
    fill: "url(#paint0_linear_242_7300)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.75,
    cy: 30.75,
    r: 10,
    stroke: "url(#paint1_radial_242_7300)",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.75,
    cy: 30.75,
    r: 2,
    fill: "#00C7FD"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 35.3362,
    y1: 30.6604,
    x2: 13.3362,
    y2: 20.6604,
    stroke: "#00C7FD",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3667 15.75H56.75V41.25C56.75 43.4591 54.9591 45.25 52.75 45.25H4.75V22.25",
    stroke: "#00C7FD",
    strokeWidth: 2.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    width: 3.5,
    height: 3.5,
    fill: "#00C7FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 17.4935L6 17.4939V22.2504H3.5V17.4935Z",
    fill: "url(#paint2_linear_242_7300)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3784 14.5L11.378 17L6.50325 17L6.50325 14.5L11.3784 14.5Z",
    fill: "url(#paint3_linear_242_7300)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_242_7300",
    x1: 11.75,
    y1: 18.75,
    x2: 15.25,
    y2: 22.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_242_7300",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.75 34.75) rotate(-157.964) scale(22.655)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_242_7300",
    x1: 4.75,
    y1: 22.25,
    x2: 4.75,
    y2: 17.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7FD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_242_7300",
    x1: 11.3784,
    y1: 15.75,
    x2: 6.25,
    y2: 15.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7FD",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdd);
export default __webpack_public_path__ + "static/media/hdd.8e7e3292576ca9471bf93f6abaf38aae.svg";
export { ForwardRef as ReactComponent };